export const DISCORD_LINK =
  process.env.NEXT_PUBLIC_DISCORD_LINK || 'https://discord.gg/hPBD3JVPSJ';

export const WEBSITE_URL =
  process.env.NEXT_PUBLIC_WEBSITE_URL || 'http://localhost:3000';
export const DISCORD_REDIRECT_URL = `https://discord.com/api/oauth2/authorize?client_id=${process.env.NEXT_PUBLIC_DISCORD_CLIENT_ID}&redirect_uri=${process.env.NEXT_PUBLIC_DISCORD_REDIRECT_URL}&response_type=code&scope=identify%20email%20guilds`;

export const TWITTER_CONNECT_URL = `https://twitter.com/i/oauth2/authorize?response_type=code&client_id=${process.env.NEXT_PUBLIC_TWITTER_CLIENT_ID}&redirect_uri=${process.env.NEXT_PUBLIC_TWITTER_REDIRECT_URL}&scope=tweet.read%20users.read%20follows.read%20follows.write&state=state&code_challenge=challenge&code_challenge_method=plain`;
export const APP_ENV = process.env.NEXT_PUBLIC_ENV;

export const DEMO_ACCOUNTS = process.env.NEXT_PUBLIC_DEMO_ACCOUNT;

export const CIPHER_SECRET = process.env.NEXT_PUBLIC_CIPHER_SECRET || 'secret';

export const WALLET_CONNECT_PROJECT_ID = process.env.WALLET_CONNECT_PROJECT_ID;

export const DISCORD_CLIENT_ID = process.env.NEXT_PUBLIC_DISCORD_CLIENT_ID;

export const CONTACT_US_FORM_URL =
  process.env.NEXT_PUBLIC_CONTACT_US_FORM_URL ||
  'https://ruc294apai1.typeform.com/to/V4xHynCB';

export const GAME_FILE_UPLOAD_SIZE =
  process.env.NEXT_PUBLIC_GAME_FILE_UPLOAD_SIZE || 3;

export const WEB_HOST_URL =
  process.env.NEXT_PUBLIC_WEB_HOST_URL || 'play.rhym.io';

export const DRAG_DROP_TOUCH_SCRIPT =
  process.env.NEXT_PUBLIC_DRAG_DROP_TOUCH_SCRIPT ||
  'https://rhym.s3.ap-south-1.amazonaws.com/website_assets/js/dragDropTouch.js';

export const BRAND_DOMAINS = process.env.NEXT_PUBLIC_BRAND_DOMAINS || '';
export const BRAND_GAMES = process.env.NEXT_PUBLIC_BRAND_GAMES || '';
export const BRAND_PAGE_TITLES =
  process.env.NEXT_PUBLIC_BRAND_PAGE_TITLES || '';

export const SERVER_URL =
  process.env.NEXT_PUBLIC_BASE_URL || 'http://localhost:5000/graphql';

export const BG_REMOVER_API_KEY = process.env.NEXT_PUBLIC_BG_REMOVER_API_KEY;

export const SHOPFLO_API_URL =
  process.env.NEXT_PUBLIC_SHOPFLO_API_URL ||
  'https://api.shopflo.co/public/api/v2/tokens';

export const SPECIAL_QUIZ_IDS = process.env.NEXT_PUBLIC_SPECIAL_QUIZ_IDS || '';

export const CUSTOM_DOMAIN_SERVER_URI =
  process.env.NEXT_PUBLIC_CUSTOM_DOMAIN_SERVER_URI || '';

export const APPSUMO_RHYM_URI =
  process.env.NEXT_PUBLIC_APPSUMO_RHYM_URI ||
  'https://appsumo.com/products/rhym/';

export const S3_BASE_URI = 'https://rhym.s3.ap-south-1.amazonaws.com';
